import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

export default function Accordion({ items, testid = "accordion" }) {
  const [open, setOpen] = useState(null);
  return (
    <div className="border-t border-border" data-testid={testid}>
      {items.map((it, i) => {
        const isOpen = open === i;
        return (
          <div key={i} className="border-b border-border">
            <h3 className="m-0">
            <button
              type="button"
              id={`${testid}-q-${i}-btn`}
              aria-controls={`${testid}-a-${i}`}
              data-testid={`${testid}-q-${i}`}
              aria-expanded={isOpen}
              onClick={() => setOpen(isOpen ? null : i)}
              className="flex w-full items-start justify-between gap-6 py-6 text-left transition-colors hover:text-accent"
            >
              <span className="font-display text-xl font-medium leading-snug tracking-tight md:text-2xl">
                {it.q}
              </span>
              <span className="mt-1 shrink-0 text-accent">
                {isOpen ? (
                  <Minus strokeWidth={1.6} className="h-5 w-5" />
                ) : (
                  <Plus strokeWidth={1.6} className="h-5 w-5" />
                )}
              </span>
            </button>
            </h3>
            {/* The answer is always in the page (search engines read it) and is
                hidden until its question is opened. */}
            <div
              id={`${testid}-a-${i}`}
              data-testid={`${testid}-a-${i}`}
              role="region"
              aria-labelledby={`${testid}-q-${i}-btn`}
              hidden={!isOpen}
              className="max-w-2xl pb-7 text-[0.98rem] leading-relaxed text-muted-foreground"
            >
              {it.a}
            </div>
          </div>
        );
      })}
    </div>
  );
}
